import { broadcast } from '@finn-no/common-browserbundle';
import React, { useEffect, useRef } from 'react';

export default function Broadcast() {
    const ref = useRef(null);

    useEffect(() => {
        const subdomain =
            window?.location?.host?.indexOf('www.finn') > -1 ? 'www' : 'dev';

        const broadcastUrl = `https://${subdomain}.finn.no/broadcasts`;

        broadcast({
            ele: ref.current,
            broadcastUrl,
        });
    }, []);

    return <div id="broadcast" ref={ref} />;
}
